var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"21","cy":"21","r":"21","fill":"#52BD95","fillOpacity":"0.2","key":0}),React.createElement("path",{"d":"M27.9019 14.3529L18.6333 23.4639L14.6781 19.5758C13.9282 18.8388 12.7122 18.8388 11.9625 19.5758C11.2125 20.3133 11.2125 21.5084 11.9625 22.2457L17.2755 27.4686C17.6503 27.8371 18.1419 28.0213 18.6333 28.0213C19.1246 28.0213 19.6163 27.8371 19.9911 27.4686L30.6173 17.0227C31.3675 16.2855 31.3675 15.0901 30.6176 14.3531C29.8679 13.6159 28.6519 13.6156 27.9019 14.3529Z","fill":"#52BD95","key":1})]);
}

Check.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = Check;

Check.default = Check;
